import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { handleSearchParams } from "@/api/handleSearchParams";
import { API_URL } from "@/constants/envVariables";
import { fetchApi } from "@/helpers/fetchApi";
import { ApiNotifications, AppError, NotificationSearchParams } from "@/types";

export const useNotifications = (
  searchParams?: NotificationSearchParams,
  options?: Omit<UseQueryOptions<ApiNotifications, AppError>, "queryKey" | "queryFn">,
) => {
  const params = handleSearchParams(searchParams);

  return useQuery<ApiNotifications, AppError>({
    queryKey: ["notifications", { ...searchParams }],
    queryFn: async () => {
      return await fetchApi(`${API_URL}/notifications${params}`);
    },
    placeholderData: (prev) => prev,
    ...options,
  });
};